/**
 * App Header Height enum
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum APP_HEADER_HEIGHT {
	SMALL = "small",
	MEDIUM = "medium",
	LARGE = "large"
}

export type APP_HEADER_HEIGHT_string = keyof typeof APP_HEADER_HEIGHT;

export const APP_HEADER_HEIGHT_default = "MEDIUM";
